import React, { useState, useEffect } from 'react';
import { listServicesAdmin, createService, updateService, deleteService } from '../../services/adminMarketplaceService';

const emptyForm = { name: '', description: '', price: '', durationMinutes: '' };

const ServiceManager = () => {
  const [services, setServices] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');

  const refresh = () => listServicesAdmin().then(setServices);
  useEffect(() => { refresh(); }, []);

  const startEdit = (service) => {
    setEditingId(service._id);
    setForm({
      name: service.name,
      description: service.description || '',
      price: service.price,
      durationMinutes: service.durationMinutes
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setForm(emptyForm);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const payload = {
      name: form.name,
      description: form.description,
      price: Number(form.price),
      durationMinutes: Number(form.durationMinutes)
    };
    try {
      if (editingId) {
        await updateService(editingId, payload);
      } else {
        await createService(payload);
      }
      cancelEdit();
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not save service');
    }
  };

  const toggleActive = async (service) => {
    await updateService(service._id, { active: !service.active });
    refresh();
  };

  const handleDelete = async (id) => {
    await deleteService(id);
    refresh();
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Massage Services</h2>
      <p className="text-sm text-gray-500">
        These services and prices power the public services page, the booking form, and the list therapists choose from when setting what they offer.
      </p>

      <form onSubmit={handleSubmit} className="bg-white p-4 rounded-lg shadow grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Service name (e.g. Swedish Massage)" className="p-2 border rounded-lg" required />
        <input value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })}
          type="number" min="0" placeholder="Price (₦)" className="p-2 border rounded-lg" required />
        <input value={form.durationMinutes} onChange={(e) => setForm({ ...form, durationMinutes: e.target.value })}
          type="number" min="1" placeholder="Duration (minutes)" className="p-2 border rounded-lg" required />
        <input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
          placeholder="Short description" className="p-2 border rounded-lg" />
        <div className="sm:col-span-2 flex gap-2">
          <button type="submit" className="bg-black text-white px-4 py-2 rounded-lg">
            {editingId ? 'Save changes' : 'Add service'}
          </button>
          {editingId && (
            <button type="button" onClick={cancelEdit} className="px-4 py-2 rounded-lg border">
              Cancel
            </button>
          )}
        </div>
        {error && <p className="sm:col-span-2 text-red-500 text-sm">{error}</p>}
      </form>

      <div className="bg-white rounded-lg shadow divide-y">
        {services.map(s => (
          <div key={s._id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-3">
            <div>
              <p className="font-medium">
                {s.name} {!s.active && <span className="text-xs text-gray-400">(inactive)</span>}
              </p>
              <p className="text-sm text-gray-500">
                ₦{s.price.toLocaleString()} · {s.durationMinutes} mins {s.description && `· ${s.description}`}
              </p>
            </div>
            <div className="flex gap-3 text-sm">
              <button onClick={() => startEdit(s)} className="text-blue-600">Edit</button>
              <button onClick={() => toggleActive(s)} className="text-gray-600">
                {s.active ? 'Deactivate' : 'Activate'}
              </button>
              <button onClick={() => handleDelete(s._id)} className="text-red-600">Delete</button>
            </div>
          </div>
        ))}
        {services.length === 0 && <p className="text-gray-500 p-3">No services yet.</p>}
      </div>
    </div>
  );
};

export default ServiceManager;
